// Merchant Fulfillment Group Actions Configuration
// Actions available to merchants for fulfillment groups

import { 
  CheckIcon, 
  TruckIcon, 
  EyeIcon,
  XMarkIcon as XIcon,
  ChatBubbleLeftEllipsisIcon as ChatIcon,
  StarIcon
} from '@heroicons/react/24/outline';

export const merchantFulfillmentGroupActions = [
  // Cancel (processing)
  {
    id: 'cancel_fulfillment_group_merchant',
    label: 'Cancel',
    type: 'secondary',
    icon: XIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'processing',
      beforeShipment: true
    },
    action: {
      type: 'modal',
      component: 'MerchantCancelGroupModal',
      mutation: 'useCancelFulfillmentGroupMutation',
      api: 'fulfillmentGroupApi'
    }
  },

  // Start Shipping (processing) - for shipping groups
  {
    id: 'start_shipping',
    label: 'Start Shipping',
    type: 'primary',
    icon: TruckIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      groupType: 'shipping',
      status: 'processing',
      allItemsReady: true
    },
    action: {
      type: 'redirect',
      target: '/merchant/ship/{groupId}'
    }
  },

  // Coordinate Pickup (processing) - for pickup groups
  {
    id: 'coordinate_pickup',
    label: 'Coordinate Pickup',
    type: 'primary',
    icon: ChatIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      groupType: 'pickup',
      status: 'processing',
      allItemsReady: true
    },
    action: {
      type: 'redirect',
      target: '/message/fulfillment-group/{groupId}'
    }
  },

  // Track Group Shipment (shipped_to_customer)
  {
    id: 'track_group_shipment',
    label: 'Track Group Shipment',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'shipped_to_customer'
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetTrackingQuery',
      api: 'fulfillmentGroupApi'
    }
  },

  // Track Group Return (return_shipped)
  {
    id: 'track_group_return',
    label: 'Track Group Return',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'return_shipped',
      hasReturnTracking: true
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetFulfillmentGroupTrackingQuery',
      api: 'deliveryApi'
    }
  },

  // Return Delivered (return_shipped) - merchant confirms receipt
  {
    id: 'return_delivered',
    label: 'Return Delivered',
    type: 'primary',
    icon: CheckIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'return_shipped'
    },
    action: {
      type: 'modal',
      component: 'ConfirmReturnDeliveryModal',
      mutation: 'useConfirmReturnDeliveryMutation',
      api: 'fulfillmentGroupApi'
    }
  },

  // View Tracking (for multiple statuses with tracking available, but NOT shipped_to_customer since that has its own action)
  {
    id: 'view_tracking_merchant',
    label: 'View Tracking',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: ['delivery_completed_to_customer', 'return_in_transit_to_merchant'],
      hasTracking: true
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetTrackingQuery',
      api: 'fulfillmentGroupApi'
    }
  },

  // Update Products Condition (return_delivered)
  {
    id: 'update_products_condition',
    label: 'Update Products Condition',
    type: 'primary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'return_delivered'
    },
    action: {
      type: 'redirect',
      target: '/dashboard/returns/update-condition/{id}'
    }
  },

  // // Review Customer (pickup_completed_by_customer) - for pickup groups
  // {
  //   id: 'review_customer_pickup',
  //   label: 'Review Customer',
  //   type: 'primary',
  //   icon: StarIcon,
  //   conditions: {
  //     userRole: 'merchant',
  //     entityType: 'fulfillmentGroup',
  //     groupType: 'pickup',
  //     status: 'pickup_completed_by_customer'
  //   },
  //   action: {
  //     type: 'redirect',
  //     target: '/fulfillmentgroup/{fulfillmentGroupId}/customer/{customerId}/review'
  //   }
  // },

  // Manage Returns (return_requested) - unified for both partial and full returns
  {
    id: 'manage_returns',
    label: 'Process Returns',
    type: 'primary',
    icon: CheckIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'fulfillmentGroup',
      status: 'return_requested'
    },
    action: {
      type: 'redirect',
      target: '/dashboard/returns/process/{id}'
    }
  }
]; 